














import Vue from 'vue';
import PhoneSMS from '@/components/campaign/PhoneSMS.vue';
import PhoneSMSContent from '@/components/campaign/PhoneSMSContent.vue';

export default Vue.extend({
  components: { PhoneSMS, PhoneSMSContent },
  props: {
    campaign: {
      type: Object,
    },
    height: {
      type: Number,
      default: 420,
    },
  },
});
